import type { MediaView } from 'common';

const normalizeApiLanguage = (language: string): string => language.trim().toLowerCase();

export interface MediaLanguageSelection {
  mediaId: string | undefined;
  transcriptionLanguage: string;
  subtitleLanguage: string | null;
}

export const languageSelectionForMedia = (
  selection: MediaLanguageSelection,
  mediaId: string | undefined,
): MediaLanguageSelection => (selection.mediaId === mediaId
  ? selection
  : { mediaId, transcriptionLanguage: 'eng', subtitleLanguage: null });

export const selectTranscriptionLanguage = (
  selection: MediaLanguageSelection,
  mediaId: string | undefined,
  language: string,
): MediaLanguageSelection => ({
  mediaId,
  transcriptionLanguage: normalizeApiLanguage(language),
  subtitleLanguage: normalizeApiLanguage(language),
});

export const selectSubtitleLanguage = (
  selection: MediaLanguageSelection,
  mediaId: string | undefined,
  language: string | null,
): MediaLanguageSelection => {
  const current = languageSelectionForMedia(selection, mediaId);
  const normalizedLanguage = language === null ? null : normalizeApiLanguage(language);
  return {
    ...current,
    transcriptionLanguage: normalizedLanguage ?? current.transcriptionLanguage,
    subtitleLanguage: normalizedLanguage,
  };
};

/** Keep player metadata on the stable English media query and overlay only a matching transcription. */
export const mediaForTranscriptionLanguage = (
  media: MediaView,
  localizedMedia: MediaView | undefined,
  language: string,
): MediaView => {
  if (language.trim().toLowerCase() === 'eng') return media;
  return {
    ...media,
    transcription: localizedMedia?._id === media._id ? localizedMedia.transcription : undefined,
  };
};
